import React, { useContext } from "react";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { BrandContext } from "./BrandContext.js";

const VenueSocial = ({ Icon, ...props }) => {
  const { isSimple, isElegant, isBrutalist, isPlayful, ...venueBrand } =
    useContext(BrandContext);

  return (
    <a
      className={classNames({
        "bg-white text-neutral-700": isElegant || isSimple,
        "bg-venue-brand text-venue-brand-contrast": isBrutalist || isPlayful,
      })}
      target="_blank"
      {...props}
    >
      <Icon size={24} />
    </a>
  );
};
const Footer = ({ venue }) => {
  const { isSimple, isElegant, isBrutalist, isPlayful } =
    useContext(BrandContext);
  const { i18n } = useTranslation();
  return (
    <footer
      className={classNames(
        "text-center sm:max-w-sm max-w-screen-sm md:max-w-xl mx-auto pt-12 pb-32 space-y-12",
        {
          "bg-white border-t-2 border-neutral-200": isElegant || isSimple,
          "bg-venue-brand text-venue-brand-contrast": isBrutalist || isPlayful,
        },
      )}
    >
      <div className="flex space-x-16 justify-center items-center">
        {venue.instagramUserName && (
          <VenueSocial
            Icon={FaInstagram}
            href={`http://instagram.com/${venue.instagramUserName}/`}
          />
        )}
        {venue.facebookPageUrl && (
          <VenueSocial Icon={FaFacebookF} href={`${venue.facebookPageUrl}`} />
        )}
        {venue.twitterUserName && (
          <VenueSocial
            Icon={FaTwitter}
            href={`http://twitter.com/${venue.twitterUserName}`}
          />
        )}
      </div>
      <div className="text-center text-xs font-sans space-y-12">
        <div className="w-2/3 pb-8 mx-auto">
          {venue.companyWebsite && (
            <a
              className={classNames("underline text-neutral-700", {
                "bg-white": isElegant || isElegant,
                "bg-venue-brand text-venue-brand-contrast":
                  isBrutalist || isPlayful,
              })}
              href={`${
                venue.companyWebsite.indexOf("http") < 0 ? "https://" : ""
              }${venue.companyWebsite}`}
            >
              {venue.name}
            </a>
          )}
        </div>
        {i18n.exists("common.getYourVenueOnlineWith") && (
          <div>
            <a
              className={classNames("text-neutral-700", {
                "bg-white": isElegant || isElegant,
                "bg-venue-brand text-venue-brand-contrast":
                  isBrutalist || isPlayful,
              })}
              href={"https://posbosshq.com/sogui"}
              target="_blank"
            >
              <Trans t={t} i18nKey={"common.getYourVenueOnlineWith"} />
            </a>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
